export default "__VITE_ASSET__BNV4rOv7__"